module.exports = __webpack_public_path__ + "static/video-appointment-6e03498223d12d02a415e62ca33041e9.jpeg";